import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../../../components/SpinnerFullScreen";
import AdminRoadmap from "./AdminRoadmap";

export const AdminRoadmapRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <AdminRoadmap />
    </Suspense>
  );
};
